export const TEXT_INPUT = 'text-input'
export const TEXT_AREA = 'textarea-input'
export const PHONE_INPUT = 'phone-input'
